import { FC, useMemo, useState } from 'react';
import { IconButton, IconButtonStyles, Icons } from '@silverfort/sf-components';

import { DEFAULT_EXPLAINABILITY_SETTINGS, EXPLAINABILITY_SETTINGS_MAP } from './Explainability/ExplainabilitySettings';

interface Props {
    guid: string;
    entityName: string;
    ruleName: string;
    scrollWidth?: number;
}

const ExplainabilityColumn: FC<Props> = ({ guid, entityName, ruleName }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const onButtonClicked = () => {
        setIsPopupOpen(true);
    };

    const onClose = () => {
        setIsPopupOpen(false);
    };
    const explainabilitySettings = useMemo(() => {
        return EXPLAINABILITY_SETTINGS_MAP[ruleName] || DEFAULT_EXPLAINABILITY_SETTINGS;
    }, [ruleName]);

    return (
        <div className="h-full w-12 absolute top-0 right-0 flex justify-center items-center bg-sf-white invisible group-hover:visible group-hover:bg-inherit">
            {explainabilitySettings.popupComponent({
                popupTitle: explainabilitySettings.popupTitle,
                guid,
                isOpen: isPopupOpen,
                onClose,
                ruleName,
                entityName
            })}
            <IconButton icon={Icons.CircleInfo} buttonStyle={IconButtonStyles.Secondary} onClick={onButtonClicked} />
        </div>
    );
};

export default ExplainabilityColumn;
